export default __webpack_public_path__ + "static/media/6.dc843455.png";